module.exports = __webpack_public_path__ + "static/media/gift-box.7424f1ac.svg";